import { XmlElement } from '@swagger-api/apidom-ns-openapi-3-0';
class Xml extends XmlElement {}
export default Xml;